import { applyMiddleware, combineReducers, legacy_createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga'
import filtersReducer from './filters/reducer';
import graphReducer from './graph/reducer';
import rootSaga from './rootSaga';
import coreReducer from './core/reducer';
import loginReducer from './login/reducer';
import { setFavorites } from './core/actions';

let storeInstance;

export const getStoreInstance = () => storeInstance;

const configureStore = () => {
    const sagaMiddleware = createSagaMiddleware();
    const rootReducer = combineReducers({
        filters: filtersReducer,
        graph: graphReducer,
        core: coreReducer,
        login: loginReducer
    });
    
    storeInstance = legacy_createStore(
        rootReducer,
        composeWithDevTools(
            applyMiddleware(sagaMiddleware)
        )
    );
    const store = storeInstance;
    // Initialize favorites from localStorage
    try {
        const raw = localStorage.getItem('relbi_user_favorites');
        const favs = raw ? JSON.parse(raw) : [];
        store.dispatch(setFavorites(Array.isArray(favs) ? favs : []));
    } catch (e) {
        store.dispatch(setFavorites([]));
    }
    
    sagaMiddleware.run(rootSaga);
    return store;
}

export default configureStore;